import { Badge, Flex } from "@/atoms"
import {
  DEFAULT_FORMAT,
  getDateInUserLocale,
  getTimestampInMillisecondsFromSecond
} from "@/helpers/date.helpers"
import { useTranslation } from "@/hooks/useTranslation"
import { Heading } from "@/molecules/Heading"

import styles from "./HeaderDeploymentsTab.module.scss"

import type { TooltipGraphProps } from "."

export const TooltipGraph = (props: TooltipGraphProps) => {
  const { count, timestamp, label } = props
  const { t } = useTranslation()

  if (count === undefined || timestamp === undefined) return null

  return (
    <Flex vertical gap={8} className={styles.tooltipWrapper}>
      <Heading
        level={6}
        title={getDateInUserLocale(
          getTimestampInMillisecondsFromSecond(Number(timestamp)),
          DEFAULT_FORMAT
        )}
      />
      <Flex align="center" justify="space-between" gap={8}>
        <Flex gap={8}>
          <Badge color="var(--daybreak-blue-4-color)" />
          <span className="sm-text-ks">{label}</span>
        </Flex>
        <span className="sm-text-ks">{`${count} ${t("general.sensor", { count })}`}</span>
      </Flex>
    </Flex>
  )
}
